import { Injectable } from '@angular/core';
import {VnaPortalService} from '../vna_portal/services/vna-portal.service';
import {VnaCampaignService} from '../vna-campaign/services/vna-campaign.service';
import {PortalServiceUpdater} from '../form/model/portal.service.updater';
import {VnaCampaignActionService} from '../vna-campaign/services/vna-campaign-action.service';

@Injectable()
export class PortalServiceFactoryService {

    constructor(private portalHandler: VnaPortalService, private campHandler: VnaCampaignService, private actionHandler: VnaCampaignActionService) { }

    getHandler(type: string): PortalServiceUpdater {

        let handler = null;
        switch (type) {
            case 'camp':
                handler = this.campHandler;
                break;
            case 'action':
                handler = this.actionHandler;
                break;
            default:
                handler = this.portalHandler;
                break;
        }

        return handler;
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/services/portal-service-factory.service.ts